import { render, staticRenderFns } from "./add_role_dialog.vue?vue&type=template&id=29c2036e&scoped=true"
import script from "./add_role_dialog.vue?vue&type=script&lang=js"
export * from "./add_role_dialog.vue?vue&type=script&lang=js"
import style0 from "./add_role_dialog.vue?vue&type=style&index=0&id=29c2036e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c2036e",
  null
  
)

export default component.exports